import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'
import de from './locales/de'

Vue.use(VueI18n)

function detectLocale(): string {
  const saved = localStorage.getItem('locale')
  if (saved) return saved

  const nav = navigator.language || ''
  const lang = nav.toLowerCase()
  if (lang.startsWith('zh')) return 'zh'
  if (lang.startsWith('de')) return 'de'
  return 'en'
}

const i18n = new VueI18n({
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages: { zh, en, de },
})

export default i18n
